import React, { memo } from 'react';
import MuiStepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import './Stepper.scss';
import useWindowDimensions from 'hooks/useWindowDimensions';

interface Props {
  steps: string[];
  currentStep: number;
  onStepClick?: (step: number) => void;
}

export const Stepper = memo<Props>(({ steps, currentStep, onStepClick }) => {
  const { device } = useWindowDimensions();

  return (
    <div className="Stepper">
      <MuiStepper activeStep={currentStep} alternativeLabel>
        {steps.map((label, index) => (
          <Step
            key={label}
            onClick={() => {
              if (currentStep <= index) return;
              onStepClick?.(index);
            }}
          >
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </MuiStepper>

      {device === 'mobile' && <div className="Stepper-mobile-label">{steps[currentStep]}</div>}
    </div>
  );
});

Stepper.displayName = 'Stepper';

export default Stepper;
